import ClassenService from '../ClassenService';

class TagService {
  getTags() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/tags`);
  }

  addTag(tagData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/tags`, 'addTag', tagData);
  }

  getTag(tagId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/tags/${tagId}`);
  }

  updateTag(tagId, tagData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/tags/${tagId}`, 'updateTag', tagData);
  }

  deleteTag(tagId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/tags/${tagId}`, 'deleteTag');
  }
}

export default new TagService();
